export default class AuthInterceptorService {
  constructor($q, $injector) {
    "ngInject";

    this.$q = $q;
    this.$injector = $injector;

    return {
      request: this.request.bind(this),
      responseError: this.responseError.bind(this)
    }
  }

  request(config) {
      config.headers = config.headers || {};

      if (config.url.includes('http') && !(config.url.includes('login'))) {
        const authService = this.$injector.get('authService');

        if(authService.isLoggedIn()) {
          var authData = JSON.parse(sessionStorage.getItem('authData'));
          if (authData) {
            config.headers.Authorization = 'Bearer ' + authData.authToken;
          }
        }
      }

      return config;
  }

  responseError(rejection) {
      if (rejection.status === 401 || rejection.status === 404) {
          const authService = this.$injector.get('authService');
          authService.unauthorized();
      }

      if (rejection.status === 403) {
        const authService = this.$injector.get('authService');
        authService.unauthorized(rejection.data.message);
      }

      return this.$q.reject(rejection);
  }
}



// WEBPACK FOOTER //
// ./client/app/common/services/authInterceptorService.js